import csTools from "cornerstone-tools";

const external = csTools.external;
const BaseTool = csTools.importInternal("base/BaseTool");
const zoomUtils = csTools.importInternal("util/zoomUtils");

/**
 * @public
 * @class CustomZoomMouseWheelTool
 * @memberof Tools
 *
 * @classdesc Tool for changing magnification with the mouse wheel.
 * @extends Tools.Base.BaseTool
 */
export class CustomZoomMouseWheelTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: "CustomZoomMouseWheel",
      supportedInteractionTypes: ["MouseWheel"],
      configuration: {
        minScale: 0.25,
        maxScale: 20.0,
        invert: false,
      },
    };

    super(props, defaultProps);
  }

  mouseWheelCallback(evt) {
    if (!evt.detail.detail.ctrlKey) {
      return;
    }

    const { element, viewport, spinY } = evt.detail;
    const { invert, maxScale, minScale } = this.configuration;
    const ticks = invert ? spinY / 4 : -spinY / 4;

    const updatedViewport = zoomUtils.changeViewportScale(viewport, ticks, {
      maxScale,
      minScale,
    });

    external.cornerstone.setViewport(element, updatedViewport);
  }
}
